import type { RefOrGetter } from "ls/common/types";
import { queryOptions, useQuery } from "@tanstack/vue-query";
import { secondsToMilliseconds } from "date-fns";
import { getUserSuggestions } from "ls/api/cloud/issue";
import { useAuth } from "ls/features/user/useAuth";
import { computed, toValue } from "vue";

export const queries = {
  userSuggestions: () => ["userSuggestions"] as const,
  userSuggestionsFile: (shortcut: string) => queryOptions({
    queryKey: [...queries.userSuggestions(), shortcut.toLowerCase()],
    queryFn: ({ signal }) => getUserSuggestions({ shortcut: shortcut.toLowerCase() }, { signal }),
    staleTime: secondsToMilliseconds(10),
  }),
};

export function useUserSuggestions(shortcut: RefOrGetter<string>) {
  const { user } = useAuth();
  const options = computed(() => {
    return {
      ...queries.userSuggestionsFile(toValue(shortcut)),
      enabled: !!user.value,
    };
  });
  return useQuery(options);
}
